import React, { Component } from 'react'
import { Container, Row, Col } from 'react-bootstrap'

import Footer from './Footer'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import '../Accueil.css'


class ConseilAdmin extends Component {
  state = {
    redirect:false,
    search: ''
    }
  
  handleCHange = event => {
    const { name, value } = event.target
    this.setState({ [name]: value })
}

  handleSubmit = event => {
    //on gere le form
    event.preventDefault()
    this.props.history.push(`/recherche/${this.state.search}`);

  }

  setRedirect = () => {
    this.setState({
      redirect: true
    })
  }
  
  handleSubmitFacebbok = () => {
    if (this.state.redirect) {
        window.location.href = "https://www.facebook.com/clubCAPN/";
    }
  }

  render () {  
    return (
      <>
        <Container fluid>
        <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />

                  <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                    <Row>
                      <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                      <div className="contact-content">
                          <h1 className="hline"><span>CONSEIL D'ADMINISTRATION 2019 - 2020</span></h1>   
                          <h2>Vous pouvez rejoindre un des membres du conseil d'administration via la directrice générale ou les coordonnateurs.</h2>
                          <p><strong>Présidente: </strong>Étienne Guindon<br />
                          <strong>Vice-président: </strong>Sarah Francoeur<br />
                          <strong>Trésorière: </strong>Mohamed Hocini <br />
                          <strong>Secrétaire: </strong>Ghislaine Roy<br />
                          <strong>Administrateur: </strong>Pascale Mclean<br />
                          <strong>Administrateur: </strong>Grégory Fuentes<br />
                          <strong>Administrateur:</strong>Sébastien Chagnon<br /></p> 
                      </div>

                      </Col>

                      <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                      <div className="contact-content">
                          <h1 className="hline"><span>ASSEMBLÉE GÉNÉRALE ANNUELLE 2020:</span></h1>   
                            <p>Vous êtes conviés à l’assemblée générale annuelle du Club Aquatique Les Piranhas du Nord 
                                qui aura lieu samedi le 17 octobre prochain à 9h30 par visioconférence, compte tenu des circonstances reliés au covid-19.
                                Pour consulter l'invitation et l'ordre du jour, ainsi que la méthode pour vous connecter,  veuillez cliquer sur le lien ci-dessous.</p> 
                                <Col lg={12} md={12} sm={12} xs={12} className="nopadding link-emploi">
                                <a href="/Communiqué_CAPN-Assembleģeannuelle.pdf" className="btn btn-primary btn-blue-light emploi" target="_blank" download>
                                TOUTES LES INFORMATIONS ICI
                                </a>
                                </Col>
                                <p>Votre club a besoin de votre participation!</p>
                      </div>

                      </Col>
                    </Row>
                  </Col>
                  

              <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
              <div className="fixed-bottom-footer"><Footer /></div>
              </Col>
            </Col>
          </Row>
        </Container>
      </>
    )
  }
  }

export default ConseilAdmin
